<template>
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M19.9999 2.76653C19.2532 3.14054 18.5064 3.26521 17.6352 3.38988C18.5064 2.8912 19.1287 2.14318 19.3776 1.14582C18.6309 1.6445 17.7597 1.89384 16.7641 2.14318C16.0173 1.39516 14.8972 0.896484 13.7771 0.896484C11.6613 0.896484 9.7945 2.76653 9.7945 5.01059C9.7945 5.3846 9.7945 5.63394 9.91896 5.88328C6.55864 5.75861 3.44723 4.1379 1.45593 1.6445C1.08256 2.26785 0.958108 2.8912 0.958108 3.76389C0.958108 5.13526 1.70485 6.38196 2.82495 7.12998C2.20267 7.12998 1.58039 6.88064 0.958108 6.6313C0.958108 8.62602 2.32713 10.2467 4.19397 10.6207C3.8206 10.7454 3.44723 10.7454 3.07386 10.7454C2.82495 10.7454 2.57604 10.7454 2.32713 10.6207C2.82495 12.2414 4.31843 13.4881 6.18527 13.4881C4.81625 14.6102 3.07386 15.2335 1.08256 15.2335C0.709195 15.2335 0.460283 15.2335 0.0869141 15.2335C1.95376 16.3555 4.06951 17.1036 6.30973 17.1036C13.7771 17.1036 17.8842 10.8701 17.8842 5.50927C17.8842 5.3846 17.8842 5.13526 17.8842 5.01059C18.7554 4.38724 19.5021 3.63922 19.9999 2.76653Z"
        :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'TwitterIcon',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
};
</script>